import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
const StudyMaterialsPage = () => {
  const [gateForm, setGateForm] = useState({ name: '', email: '', phone: '' });
  const [gateOpen, setGateOpen] = useState(false);
  const [pending, setPending] = useState(null); // which download

  const handleGateSubmit = (e) => {
    e.preventDefault();
    setGateOpen(false);
    alert(`Thank you! Your ${pending} download link has been sent to ${gateForm.email}.`);
  };

  const openGate = (which) => { setPending(which); setGateOpen(true); };

  const faqs = [
    { q: 'Are CUET study materials free?', a: 'Yes, basic materials are free after a quick registration.' },
    { q: 'Are these materials updated?', a: 'Yes, they are aligned with the latest CUET syllabus.' },
    { q: 'Do I need to register to download?', a: 'Yes, quick registration ensures access to your download link.' },
    { q: 'Are materials available for all subjects?', a: 'Yes, for CUET UG, PG, and UGC NET/JRF.' },
    { q: 'How should I use study material effectively?', a: 'Combine it with mock tests and PYQs for the best results.' },
  ];

  const categories = [
    { icon: '📘', title: 'CUET UG Study Material', desc: 'Language subjects, Domain subjects & General Test', key: 'CUET UG' },
    { icon: '📗', title: 'CUET PG Study Material', desc: 'Subject-specific, advanced topics & concept learning', key: 'CUET PG' },
    { icon: '📙', title: 'UGC NET / JRF Material', desc: 'Paper 1 (General) & subject-specific preparation', key: 'UGC NET/JRF' },
  ];

  return (
    <>
      <Helmet>
        <title>CUET Study Material Free Download | UG, PG & NET/JRF PDFs</title>
        <meta name="description" content="Download CUET study material for UG, PG & NET/JRF. Get free PDFs, notes & important topics to boost your preparation." />
        <meta name="keywords" content="CUET study material, CUET UG study material, CUET PG study material, UGC NET study material, free CUET PDFs" />
        <link rel="canonical" href="https://besst.in/study-materials" />
        <meta property="og:title" content="CUET Study Material Free Download | UG, PG & NET/JRF PDFs" />
        <meta property="og:description" content="Download free CUET study material for UG, PG & NET/JRF. Get PDFs, notes & important topics." />
        <meta property="og:url" content="https://besst.in/study-materials" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="BESST" />
      </Helmet>
      <div className="min-h-screen pt-32 pb-20">
        {/* Hero */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <div className="text-center max-w-4xl mx-auto">
            <div className="hero-badge mx-auto mb-6">📚 Free Download</div>
            <h1 className="text-4xl lg:text-6xl font-extrabold gradient-text mb-6 leading-tight">
              CUET Study Material Free Download
            </h1>
            <p className="text-xl text-text-muted mb-4">
              Free downloadable PDFs for CUET UG, CUET PG, and UGC NET/JRF
            </p>
            <p className="text-text-muted mb-8">✅ Free PDFs &nbsp;•&nbsp; ⚡ Instant Download &nbsp;•&nbsp; 🔄 Updated Content</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => openGate('CUET UG Materials')} className="btn-primary px-8 py-4 text-lg font-bold rounded-xl">
                📥 Download Study Materials Now
              </button>
              <Link to="/subscriptions" className="px-8 py-4 text-lg font-bold rounded-xl border border-glass-border text-text-light hover:bg-white/5 transition-colors">
                Get Full Access
              </Link>
            </div>
            <p className="text-xs text-accent-gold mt-4">⚡ Free access available for limited time</p>
          </div>
        </div>

        {/* Why use study material */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-3xl font-bold gradient-text text-center mb-10">Prepare Smart with the Right Resources</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {['Understand concepts clearly', 'Focus on important topics', 'Save time in preparation', 'Improve exam performance'].map(b => (
              <div key={b} className="glass-card text-center p-4">
                <span className="text-green-400 text-2xl block mb-2">✔</span>
                <p className="text-text-muted text-sm">{b}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Download Categories */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-3xl font-bold gradient-text text-center mb-10">Download CUET Study Material Instantly</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {categories.map(cat => (
              <div key={cat.key} className="glass-card text-center">
                <div className="text-5xl mb-4">{cat.icon}</div>
                <h3 className="text-lg font-bold text-text-light mb-2">{cat.title}</h3>
                <p className="text-text-muted text-sm mb-6">{cat.desc}</p>
                <button onClick={() => openGate(cat.key)} className="btn-primary w-full py-3 font-semibold rounded-xl">
                  📥 Download {cat.key} Materials
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* What you get */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <div className="glass-card max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-text-light mb-6">📚 What You Get in Study Materials</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {['Topic-wise notes', 'Concept explanations', 'Important questions', 'Exam-oriented content', 'Easy-to-download PDFs', 'Updated as per latest syllabus'].map(f => (
                <div key={f} className="flex items-center gap-3 p-3 bg-bg-secondary rounded-xl">
                  <span className="text-primary text-lg">→</span>
                  <span className="text-text-light text-sm">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Cross-sell */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-2xl font-bold gradient-text text-center mb-8">Go Beyond Study Material</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[
              { label: 'Mock Tests', href: '/test-zone', icon: '🧪' },
              { label: 'PYQs', href: '/pyq-cuet', icon: '📄' },
              { label: 'Current Affairs', href: '/current-affairs-test', icon: '🌍' },
              { label: 'Counselling', href: '/cuet-counselling', icon: '🎓' },
            ].map(l => (
              <Link key={l.label} to={l.href} className="glass-card text-center hover:border-primary/50 transition-colors p-4">
                <div className="text-3xl mb-2">{l.icon}</div>
                <div className="text-text-light text-sm font-semibold">{l.label}</div>
              </Link>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-2xl font-bold gradient-text text-center mb-8">Frequently Asked Questions</h2>
          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((f, i) => (
              <details key={i} className="glass-card">
                <summary className="font-semibold text-text-light cursor-pointer list-none flex justify-between items-center">
                  {f.q} <span className="text-primary text-xl">+</span>
                </summary>
                <p className="text-text-muted mt-3 text-sm">{f.a}</p>
              </details>
            ))}
          </div>
        </div>

        {/* Final CTA */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="glass-card text-center max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-text-light mb-3">Download CUET Study Material & Start Today</h2>
            <p className="text-text-muted mb-6">Don't wait — get access to high-quality study resources and prepare smarter.</p>
            <button onClick={() => openGate('All Materials')} className="btn-primary px-8 py-3 font-bold rounded-xl">
              📥 Download Now
            </button>
          </div>
        </div>

        {/* Lead Gate Modal */}
        {gateOpen && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-[#1a1a2e] border border-glass-border rounded-2xl w-full max-w-md p-6 shadow-2xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-text-light">📥 Download {pending}</h3>
                <button onClick={() => setGateOpen(false)} className="text-text-muted text-2xl">&times;</button>
              </div>
              <p className="text-text-muted text-sm mb-4">Quick registration to unlock your download</p>
              <form onSubmit={handleGateSubmit} className="space-y-3">
                <input required placeholder="Full Name *" value={gateForm.name} onChange={e => setGateForm({...gateForm, name: e.target.value})}
                  className="w-full px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary" />
                <input required type="email" placeholder="Email Address *" value={gateForm.email} onChange={e => setGateForm({...gateForm, email: e.target.value})}
                  className="w-full px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary" />
                <input required type="tel" placeholder="Phone Number *" value={gateForm.phone} onChange={e => setGateForm({...gateForm, phone: e.target.value})}
                  className="w-full px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary" />
                <button type="submit" className="w-full btn-primary py-3 font-bold rounded-xl">📥 Get Download Link</button>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StudyMaterialsPage;
